import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "@/packages/utils";
import { useFilter } from "./FilterContext";
import { FilterPill } from "./FilterPill";

export function FilterPillBar() {
  const { t } = useTranslation("common");
  const { filters, logic, toggleLogic, clearAllFilters } = useFilter();

  if (filters.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.2 }}
      className="flex flex-wrap items-center gap-2 pb-3"
    >
      <AnimatePresence mode="popLayout">
        {filters.map((filter, idx) => (
          <span key={filter.id} className="contents">
            {/* AND/OR toggle between pills when 2+ filters */}
            {idx > 0 && filters.length >= 2 && (
              <motion.button
                layout
                key={`logic-${filter.id}`}
                onClick={toggleLogic}
                className="rounded-full bg-card-hover px-2 py-0.5 text-[11px] font-medium text-muted uppercase hover:text-primary transition-colors cursor-pointer"
              >
                {logic}
              </motion.button>
            )}
            <FilterPill filter={filter} />
          </span>
        ))}
      </AnimatePresence>

      {/* Clear all button */}
      {filters.length > 0 && (
        <motion.button
          layout
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={clearAllFilters}
          className="text-[12px] text-muted hover:text-primary transition-colors cursor-pointer ml-1"
        >
          {t("ui.filter.clearAll")}
        </motion.button>
      )}
    </motion.div>
  );
}
